import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { GeoLocationAction } from "../../redux/location";

const GeoLocationButton = () => {

    const dispatch = useDispatch()
    
    const [location, setLocation] = useState(null)

    
            const handleClick = () => {

                console.log(location)
            
                dispatch(GeoLocationAction({ location: location }))  
            }

            useEffect(() => {

                if ("geolocation" in navigator) {

                    navigator.geolocation.getCurrentPosition(function(position) {
                    
                        setLocation({latitude: position.coords.latitude, longitude: position.coords.longitude})
        
                        console.log(location)
                        
                    });
        
                    } else {
                    console.log("nop")
                    }
              
            }, [])
            
            

    return (
    

        <button className="geoButton" onClick={handleClick}>
            <img src={require("../../img/location.svg").default} />
        </button>
  
  )
  
};

export default GeoLocationButton;
